import React from "react";
import { Outlet } from "react-router-dom";
import FoutaHeader from "./FrontHeader/FoutaHeader";
import FoutaFooter from "./FrontFooter/FoutaFooter";
// import RendezVous from "../composantFouta/RendezVous";

const FoutaLayout = () => {
  return (
    <div className="landing-page-component">
      <FoutaHeader />
      {/* Formulaire RDV conservé au cas où — actuellement les prises de RDV passent par WhatsApp.
      <RendezVous
        isOpen={showRendezVous}
        onClose={() => setShowRendezVous(false)}
      />
      */}
      <div className="page-conten">
        <Outlet />
      </div>
      <FoutaFooter />
    </div>
  );
};

export default FoutaLayout;